import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { getCities } from 'models/cities'; // Importing getCities model
import { getTags } from 'models/tags'; // Importing getTags model
import { getPositions } from 'models/positions'; // Importing getPositions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * FilterFlujoCajaView class extends JetView to create a filter form for cash flow.
 */
export default class FilterFlujoCajaView extends JetView {
    /**
     * Configures the layout of the filter form.
     * @returns {Object} The configuration object for the form.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date range
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for datepicker
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
                {
                    view: 'datepicker', // Datepicker input
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for date
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar', // Suggestion type
                        body: {
                            maxDate: new Date(), // Maximum date allowed
                        },
                    },
                },
            ],
        };

        const center_left = {
            // Center left section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Rich select for country selection
                    name: 'Country',
                    id: 'country',
                    localId: 'Country:combo',
                    label: "<span class='icon-language'></span>" + _('País'), // Label for country
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        const center_right = {
            // Center right section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Rich select for currency selection
                    name: 'Currency',
                    id: 'currency',
                    localId: 'Currency:combo',
                    label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'), // Label for currency
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        const right = {
            // Right section of the form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for ticket number
                    name: 'NoTicket',
                    type: 'number',
                    label: "<span class='icon-ticket'></span>" + _('No. Ticket'), // Label for ticket number
                    labelPosition: 'top',
                    placeholder: _('No. Ticket'), // Placeholder text
                    invalidMessage: _('No. Ticket is required'), // Validation message
                },
            ],
        };

        const upper_section = {
            // Upper section containing all input fields
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Arranging sections in columns
                },
            ],
        };

        const buttons = {
            // Button section for actions
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        // Clear form on click
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Handle consult action
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('flujoCajaHijos:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} form - The form instance.
     */
    init(form) {
        webix.ready(function () {
            // Wait for webix to be ready
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if condition is true
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Attach event after rendering Datepicker
            devConfig.setDateModal(lang); // Set date modal configuration
        });

        webix // AJAX request to fetch countries
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handling
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handling
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize JSON keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    var optionsProvinceRegions = $$('country').getList(); // Get country list
                    optionsProvinceRegions.clearAll(); // Clear existing options
                    optionsProvinceRegions.parse(data.Data); // Populate with new data
                },
            });

        $$('country').attachEvent('onChange', function (newv, oldv) {
            // Handle country change event
            var optionscountries = this.getList().getItem(newv); // Get selected country
            var optionscurrencies = $$('currency').getList(); // Get currency list
            optionscurrencies.clearAll(); // Clear existing currency options
            optionscurrencies.parse(optionscountries.currencies); // Populate currencies based on selected country
            webix.message('Value changed from: ' + oldv + ' to: ' + newv); // Show change message
        });
    }
}

// FILE DOCUMENTED
